import React, {useCallback, useEffect, useRef, useState} from 'react'
import {withTranslation} from 'react-i18next'

import MODES from 'constants/MODES'
import useSearchContext from 'components/SearchContext/useSearchContext'
import SearchResultsHandler from 'modules/AppHeader/SearchResultsHandler'
import LogoAndLinks from 'modules/AppHeader/LogoAndLinks'
import ProductCategories from 'modules/AppHeader/ProductCategories'
import ActionButtons from 'modules/AppHeader/ActionButtons'

const navBarRoutes = ['search', 'category']
const shouldBeOpen = history => (navBarRoutes.indexOf(history.location.pathname.split('/')[1]) > -1)

let timeoutReset = 0

const AppHeader = ({history, match: {params}, mode: modeProp, t}) => {
  const {mode, setMode} = useSearchContext()

  const [isOpen, setOpen] = useState(shouldBeOpen(history))
  const [isSearching, setSearching] = useState(false)
  const [data, setData] = useState({init: true})
  const [searchValue, setSearchValue] = useState(params.searchValue ?? '')

  useEffect(() => {
    if (shouldBeOpen(history)) setSearchValue(params.searchValue ?? '')
  }, [history, params.searchValue])

  useEffect(() => {
    setTimeout(() => {
      setMode(modeProp)
    }, shouldBeOpen(history) ? 0 : timeoutReset)
    timeoutReset = 750
  }, [history, modeProp, setMode])

  const timeout1 = useRef()
  const timeout2 = useRef()
  const onInteract = useCallback((focus, value) => {
    if (focus || value.length) {
      setSearching(true)
      setOpen(true)
      clearTimeout(timeout1.current)
      clearTimeout(timeout2.current)
      timeout1.current = setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
      }, 1000)
      timeout2.current = setTimeout(() => {
        document.documentElement.scrollTop = 0
      }, 1500)
    } else {
      setSearching(false)
      const open = shouldBeOpen(history)
      setOpen(open)
      if (!open) {
        clearTimeout(timeout1.current)
        clearTimeout(timeout2.current)
        document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
      }
    }
  }, [history])

  const closeSearchMain = useCallback(() => {
    setTimeout(() => {
      setSearchValue('')
      setData({init: true})
    }, 750)
    onInteract(false, '')
  }, [onInteract])

  useEffect(() => {
    if (shouldBeOpen(history)) {
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
    }

    history.listen(() => {
      if (!shouldBeOpen(history)) {
        closeSearchMain()
      } else {
        onInteract(false, '')
      }
    })
  }, [closeSearchMain, history, onInteract])

  return (
    mode ? <nav id='nav' className={isOpen ? 'navCollapsed' : ''}>
      <div>
        <LogoAndLinks t={t}>
          <ProductCategories t={t} history={history}/>
          <ActionButtons t={t} history={history} autocompleteSearching={mode === MODES.autocomplete && isSearching} closeSearchMain={closeSearchMain}/>
        </LogoAndLinks>

        <div id='nav-autocomplete'>
          <SearchResultsHandler
            onInteract={onInteract}
            isOpen={isOpen}
            isSearching={isSearching}
            setSearching={setSearching}
            history={history}
            alias={params.alias}
            data={data}
            setData={setData}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            mode={mode}
          />
        </div>
      </div>
    </nav> : ''
  )
}

export default withTranslation()(AppHeader)
